<script>
import { mapGetters, mapState, mapActions } from "vuex";

import orderSchedulerHelper from "@/utils/helpers/orderSchedulerHelper";

import WontHaveInstantSupport from "@/components/_Shared/Warnings/WontHaveInstantSupport";

import Title from "@/components/_Shared/Title";
import OrderReview from "./OrderReview";
import ReschedulePreference from "./ReschedulePreference";
import ProductsPreference from "./ProductsPreference";

export default {
  components: {
    Title,
    OrderReview,
    ReschedulePreference,
    ProductsPreference,
    WontHaveInstantSupport
  },

  data() {
    return {
      preloader: false,
      showWontHaveInstantSupportDialog: false,
      acceptSupportAlert: false
    };
  },

  methods: {
    ...mapActions("user", [
      "showEmailNotVerifiedDialog",
      "createPaymentGateways",
      "clearSetInterval"
    ]),
    ...mapActions("orderScheduler", [
      "create",
      "applyOrderCouponOnCreation",
      "resetState",
      "unsetOrderConfirmation"
    ]),
    ...mapActions("allowProfessionalChangePreference", ["setPreference"]),
    ...mapActions("requireProductsPreference", ["setProductPreference"]),

    async submit() {
      this.preloader = true;

      if (
        orderSchedulerHelper.notBusinessDay(this.date) &&
        !this.acceptSupportAlert
      ) {
        this.showWontHaveInstantSupportDialog = true;
        return;
      }

      if (this.hasNoVerifiedEmail) {
        this.showEmailNotVerifiedDialog();
        return;
      }

      if (this.mustCreatePaymentGateways()) {
        const createdPG = await this.createPaymentGateways();
        this.preloader = createdPG;

        return;
      }

      await this.createOrder();
    },

    async createOrder() {
      try {
        const order = await this.create();

        await this.applyOrderCouponOnCreation(order);

        await this.setPreference(order.id);
        await this.setProductPreference(order.id);

        this.resetState();

        pintrk("track", "addtocart", {
          value: 20,
          order_quantity: 1,
          currency: "BRL"
        });

        this.$router.push({
          name: "order-checkout",
          params: { order_id: order.id }
        });
      } catch (e) {
        this.preloader = false;
      }
    },

    async wontHaveInstantSupport(response) {
      this.showWontHaveInstantSupportDialog = false;

      if (!response) {
        this.preloader = false;
        return;
      }
      this.acceptSupportAlert = true;
      await this.submit();
    },

    mustCreatePaymentGateways() {
      return this.userStatus === "email_verified";
    }
  },

  computed: {
    ...mapState("orderScheduler", ["checkoutPreloader"]),
    ...mapGetters("orderScheduler", ["date", "professional"]),
    ...mapGetters("user", ["userStatus", "hasNoVerifiedEmail"])
  },

  watch: {
    userStatus(newStatus) {
      // Ensure the creation of the pga and pgc when the user email is verified on the creation of a new order.
      if (newStatus === "email_verified") {
        this.createPaymentGateways();
      }

      // Ensure the order is created after the pga and pgc were created on the creation of a new order.
      if (newStatus === "active") {
        this.createOrder();
      }
    }
  },

  async beforeDestroy() {
    await this.clearSetInterval();
  }
};
</script>

<template>
  <div class="card root">
    <Title title="Confirme a sua limpeza" />

    <OrderReview />

    <ReschedulePreference />

    <ProductsPreference v-if="professional.professional_rating && professional.professional_rating.has_products" />

    <div class="actions">
      <button
        class="btn bg-green btn-confirmation"
        :disabled="preloader"
        :class="{'btn--loading': preloader}"
        @click="submit"
      >
        <span>ir para pagamento</span>
      </button>

      <button
        class="btn btn-go-back"
        :disabled="preloader"
        :class="{'btn--loading': preloader}"
        @click="unsetOrderConfirmation"
      >
        <span>voltar</span>
      </button>
    </div>

    <WontHaveInstantSupport
      :visible="showWontHaveInstantSupportDialog"
      :date="date"
      @accept="() => wontHaveInstantSupport(true)"
      @reject="() => wontHaveInstantSupport(false)"
    />
  </div>
</template>

<style scoped>
.root {
  width: calc(100% - 32px);
  max-width: 450px;
  margin: 0 auto;
  user-select: none;
}

.card {
  padding: 16px;
}

.actions {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.btn-confirmation {
  max-width: 100%;
  width: 250px;
}

.btn-go-back {
  max-width: 100%;
  width: 150px;
}
</style>



// WEBPACK FOOTER //
// src/components/PurchaseFlow/Components/Scheduler/Confirmation/Index.vue